export type FlowFocus =
  | { type: 'node'; name: string }
  | { type: 'link'; index: number }
  | null

export interface FlowEdge {
  source: string
  target: string
}

export interface FlowHighlight {
  nodes: Set<string>
  links: Set<number>
}

// What stays lit while the reader points at one node or link: the link
// and its two ends, or the node with every link that touches it.
export function flowHighlight(
  focus: FlowFocus,
  edges: FlowEdge[],
): FlowHighlight | null {
  if (!focus) return null
  const litLinks =
    focus.type === 'link'
      ? [focus.index]
      : edges.flatMap((edge, index) =>
          edge.source === focus.name || edge.target === focus.name
            ? [index]
            : [],
        )
  const nodes = new Set<string>(focus.type === 'node' ? [focus.name] : [])
  for (const index of litLinks) {
    const edge = edges[index]
    if (!edge) continue
    nodes.add(edge.source)
    nodes.add(edge.target)
  }
  return { nodes, links: new Set(litLinks) }
}
